import { STAFF_MANAGE_TOKEN, STAFF_MANAGE_USER, STAFF_MANAGE_LOCALE } from "constants/"
import imageApi from "api/image";

export * from './map';

export const isUserLoggedIn = () => localStorage.getItem(STAFF_MANAGE_USER)

export const setToken = (token) => localStorage.setItem(STAFF_MANAGE_TOKEN, token)

export const removeToken = () => localStorage.removeItem(STAFF_MANAGE_TOKEN)

export const getToken = () => localStorage.getItem(STAFF_MANAGE_TOKEN)

export const setUser = (user) => localStorage.setItem(STAFF_MANAGE_USER, JSON.stringify(user))

export const getUser = () => isUserLoggedIn() && JSON.parse(localStorage.getItem(STAFF_MANAGE_USER))

export const removeUser = () => localStorage.removeItem(STAFF_MANAGE_USER)

export const getLocale = () => localStorage.getItem(STAFF_MANAGE_LOCALE)

export const setLocale = (locale) => localStorage.setItem(STAFF_MANAGE_LOCALE, locale)

export const formatCurrency = (value = 0) => {
    let currency = parseFloat(value).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })

    currency = currency.replaceAll(".", "+");

    currency = currency.replaceAll(",", ".");

    currency = currency.replaceAll("+", ",");

    return currency;
}

export const formatPercent = (value = 0) => {
    return (value * 100).toFixed(2) + ' %'
}

export const renderHtmlTextBreakLine = (text) => {
    return text?.replace(/\n/g, '<br>');
}

export const normFile = (e) => {
    if (Array.isArray(e)) {
        return e;
    }

    if (e?.fileList?.length > 0) {
        let res = e.fileList;
        res = res.map(file => ({
            ...file,
            status: 'done',
        }))

        return res;
    }

    return e?.fileList;
};

export const handleUploadImage = async (file, isExact = false) => {
    return new Promise(async (resolve, reject) => {
        try {
            const formData = new FormData();
            formData.append("file", file.originFileObj || file);
            //check is file image
            if (!file.type.includes('image')) {
                formData.append("resource_type", "raw");
            }
            if (isExact) {
                formData.append("public_id", file.name);
            }

            const response = await imageApi.uploadImage(formData)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}